import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { toastError, countryActionId, cityActionId, industryActionId, stateActionId } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from "../../../utils/pagination";
import Header from '../../../common_components/Header';
import { get_benefitList_action } from '../../../actions/userAction/benefit_action';
import moment from 'moment';
import Loader from '../../../utils/Loader';

class BenefitsList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false, isFilterShow: false,
            isOtherPreName: false,
            MemberID: '', currentPage: 1, benefitList: [],
            FullAccess: false, ReadAccess: false, WriteAccess: false, UpdateAccess: false, DeleteAccess: false, DownloadAccess: false, Is_SpecialAccess: false, SendAccess: false
        }
        this.updateItem = this.updateItem.bind(this);
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        } else {
            window.scrollTo(0, 0)
            const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];
            const proformaListModule = loginAccessList.find(module => module.ModuleName === "Benefits");

            if (proformaListModule) {
                const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = proformaListModule;

                if (!FullAccess && !ReadAccess) {
                    this.props.navigate('/login'); // Navigate to login if no access
                } else {
                    this.setState({
                        FullAccess: !!FullAccess,
                        ReadAccess: !!ReadAccess,
                        WriteAccess: !!WriteAccess,
                        UpdateAccess: !!UpdateAccess,
                        DeleteAccess: !!DeleteAccess,
                        DownloadAccess: !!DownloadAccess,
                        Is_SpecialAccess: !!Is_SpecialAccess,
                        SendAccess: !!SendAccess
                    });

                    if (FullAccess) {
                        this.setState({
                            ReadAccess: true,
                            WriteAccess: true,
                            UpdateAccess: true,
                            DeleteAccess: true,
                            DownloadAccess: true,
                            Is_SpecialAccess: true,
                            SendAccess: true
                        });
                    }
                }
            } else {
                this.props.navigate('/login');
            }

            if (loginAccessList.length) {
                this.getFillList(countryActionId, '', '', '', '').then(() => {
                    this.getFillList(industryActionId, '', '', '', '').then(() => {
                        this.getBenefitList()
                    })
                })
            }
        }
    }

    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === countryActionId) {
                            this.setState({ countryList: data.data })
                            resolve(true)
                        }
                        else if (actionID === stateActionId) {
                            data.data.length > 0 && this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === cityActionId) {
                            data.data.length > 0 && this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === industryActionId) {
                            this.setState({
                                industryList: data.data,
                                // tempCityList: data.data,
                            })
                            resolve(true)
                        }
                    }
                })
        })
    }

    getBenefitList() {
        this.setState({ isLoading: true });

        this.props
            .get_benefitList_action()
            .then((data) => {
                if (data.error !== 1) {
                    const sortedData = this.sortBenefits(data.data);
                    this.setState({ benefitList: sortedData, isLoading: false });
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.data.ErrorMsg);
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
                toastError("Failed to fetch benefits data.");
            });
    }

    sortBenefits(data) {
        return data.sort((a, b) => a.seqno - b.seqno);
    }

    generateHierarchy(data) {
        const map = {};
        const roots = [];

        // Create map with BenefitsID as key
        data.forEach((item) => {
            map[item.BenefitsID] = { ...item, children: [] };
        });

        // Populate hierarchy
        data.forEach((item) => {
            if (item.ParentID === 0) {
                roots.push(map[item.BenefitsID]);
            } else {
                map[item.ParentID]?.children.push(map[item.BenefitsID]);
            }
        });

        return roots;
    }

    renderHierarchy(items, level = 0) {
        if (items.length === 0) {
            return (
                <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>No Record Found</td>
                </tr>
            );
        }
        return items.map((item) => (
            <React.Fragment key={item.BenefitsID}>
                <tr
                    style={{
                        backgroundColor: item.ParentID === 0 ? "#d1e7dd" : "transparent",
                        fontWeight: item.ParentID === 0 ? "bold" : "normal"
                    }}
                >
                    <td>{item.seqno}</td>
                    <td style={{ paddingLeft: `${level ? level * 30 : 10}px` }}>{item.Name}</td>
                </tr>
                {item.children.length > 0 && this.renderHierarchy(item.children, level + 1)}
            </React.Fragment>
        ));
    }


    updateItem = (item) => {
        this.setState({ currentPage: item });
    };

    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }
    render() {
        const { isLoading, industryList, countryList, companyName, currentPage, benefitList, isFilterShow, 
            FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = this.state
        const hierarchicalData = this.generateHierarchy(benefitList);
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                    // <></>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <div class="row mt-15">
                            <section className="table_section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="card mb-2" >
                                                <div className="card-header py-2">
                                                    <h6 className='pt-2' style={{ float: 'left' }}>Benefits</h6>
                                                    {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                                                        <a style={{ float: 'right' }}
                                                            href="javascript:void(0);"
                                                            className="btn btn-purple custom_btn"
                                                            title="Filter"
                                                            data-toggle="modal"
                                                            data-target="#filter_modal"
                                                            onClick={() => this.toggleFilterCollapse()}
                                                        >
                                                            <i className="fa fa-filter" />
                                                        </a>

                                                    </> : <></>}
                                                </div>
                                                <ul className="list-group list-group-flush" >
                                                    {isFilterShow && <>

                                                        <li className="list-group-item"><div className="row">
                                                            {/* <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>Company Name<span className="red-star text-danger">*</span></label>
                                                                    <input type="text" class="form-control" placeholder="Enter Company name" value={companyName} onChange={(e) => this.setState({ companyName: e.target.value })} maxLength={1000} />

                                                                </div>
                                                            </div> */}

                                                        </div></li>
                                                    </>}
                                                </ul>
                                            </div>
                                            <div className="card ">

                                                <div className="card-body">

                                                    <div className="custom_table">
                                                        <div className="hack1">
                                                            <div className="hack2">
                                                                <table className="table table-bordered table-striped mg-b-0">
                                                                    <tbody id="myTable">
                                                                        {this.renderHierarchy(hierarchicalData)}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>

                    </div >
                </section >
                {/* <Footer /> */}

            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_benefitList_action })(BenefitsList));
